import { render } from "./AddResource.vue?vue&type=template&id=f7bb8700&ts=true"
import script from "./AddResource.vue?vue&type=script&lang=ts"
export * from "./AddResource.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__